import { useState, useEffect, useCallback } from 'react';
import { createGlobalState } from 'react-use';

const initialState = {
	exhID: '', // 展覽ID
	Timeout: null, // 重新產生UUID的秒數
	recordAPI: '', // 單向紀錄用API
	recordUser: '', // 單向紀錄用API呼叫用帳號
	recordPassword: '', // 單向紀錄用API呼叫用密碼
	recommandAPI: '', // 推薦用API
};

const useConfigState = createGlobalState(initialState);

const useConfig = () => {
	const [configState, setConfigState] = useConfigState(initialState);
	const [configFetched, setConfigFetched] = useState(false);

	useEffect(() => {
		if (!configFetched) {
			fetch('./config.json')
				.then(response => response.json())
				.then(config => {
					setConfigFetched(true);
					setConfigState((state) => {
						return {
							...state,
							...config,
						};
					});
				})
				.catch(error => console.error(error));
		}
	}, [configFetched, setConfigState]);

	return {
		...configState,
	};
}
export default useConfig;